export const subjectLabels: Record<string, string> = {
  matematik: 'Matematik',
  fizik: 'Fizik',
  kimya: 'Kimya',
  biyoloji: 'Biyoloji',
  turkce: 'Türkçe',
  tarih: 'Tarih',
  cografya: 'Coğrafya',
  felsefe: 'Felsefe',
  edebiyat: 'Edebiyat',
  diger: 'Diğer',
};

export const universityYearLabels: Record<string, string> = {
  hazirlik: 'Hazırlık',
  sinif1: '1. Sınıf',
  sinif2: '2. Sınıf',
  sinif3: '3. Sınıf',
  sinif4: '4. Sınıf',
  yuksek_lisans: 'Yüksek Lisans',
  doktora: 'Doktora',
  mezun: 'Mezun',
};

export const legacyGradeLabels: Record<string, string> = {
  '9': '9. Sınıf',
  '10': '10. Sınıf',
  '11': '11. Sınıf',
  '12': '12. Sınıf',
  mezun: 'Mezun (eski)',
};

export const subjectColors: Record<string, string> = {
  matematik: '#3b82f6',
  fizik: '#8b5cf6',
  kimya: '#06b6d4',
  biyoloji: '#10b981',
  turkce: '#f59e0b',
  tarih: '#ef4444',
  cografya: 'var(--accent-primary)',
  felsefe: '#6366f1',
  edebiyat: '#f97316',
  diger: '#64748b',
};

export const SUBJECT_OPTIONS = Object.keys(subjectLabels);
export const UNIVERSITY_YEAR_OPTIONS = Object.keys(universityYearLabels);

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins} dk önce`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} saat önce`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} gün önce`;
  return `${Math.floor(days / 30)} ay önce`;
}
